





























































    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    declare const ol: any;
    import navigationDrawer from '../NavigationDrawer/navigationDrawer.vue';
    import applicationPanel from '../Panels/applicationPanel.vue';
    import contentControls from '../ContentControls/appControls.vue';
    import speedDial from '../speedDial/speedDial.vue';
    import toolstrip from '../Toolstrip/toolstrip.vue';
    import activitySnackBar from '../Notifications/activitySnackbar.vue';
    import errorSnackbar from '../Notifications/errorSnackbar.vue';
    import cookieSnackbar from '../Notifications/cookieSnackbar.vue';
    import notificationSnackbar from '../Notifications/notificationSnackbar.vue';
    import interactiveSnackbar from '../Notifications/interactiveSnackbar.vue';
    import { LayerStatus } from '../../../GeognoSIS/Overlay';
    import { AjaxWrapper } from '../../../Core/AjaxWrapper';
    import { CookieManager } from '../../../Core/CookieManager';
    import { LayerFactory } from '../../../ol/LayerFactory';
    import cultureSelector from './cultureSelector.vue';
    import homeButton from './home.vue'
    import profile from './profile.vue';
    import { IBookmark, IUrlParameters, IUrlParamterHandler, IWatermark, IInitialView } from '../../../../../../CommonScripts/Abstractions';     

    export default Vue.extend({
        name: 'application',
        props: ['panels', 'toolbar', 'mapContainerId', 'mapControls', 'showCookieConsent'],
        data() {
            return {
                menuVisible: false,
                mapFeaturesVisible: false,
                appDrawVisible: false,
                cookieManager: new CookieManager(),
                appPanelVisible: false,
                humanDialogVisible: false,
                dataLayers: [],
                baseLayers: [],
                userIsHuman: false,
                urlPromises: [],
                urlFullMapPromises:[]
            };
        },
        computed: {
            menuTitle(): string {
                let retVal: string = '';
                if (this.$store.getters['map/getMapTitle']) {
                    retVal = this.$vuetify.lang.t(this.$store.getters['map/getMapTitle']);
                }
                return retVal;
            },
            showCookieSnackbar(): boolean {
                return this.showCookieConsent && !this.cookieManager.haveConsent();
            },
            useDarkText(): boolean {
                return this.$store.getters['useDarkText'];
            },
            isMobile(): boolean {
                return this.$vuetify.breakpoint.mobile;
            },
            appSidePanelClass(): string {
                let cssclass = '';
                if (this.isMobile)
                    cssclass = 'appSidePanelBottom';
                else
                    cssclass = 'appSidePanel'
                return cssclass;
            },            
            btnConfirmText(): string {
                return this.$vuetify.lang.t('webmap.buttonText.confirm');
            },
            showHumanDialogSetting(): boolean {                
                return this.$store.getters['getShowHumanDialog'];
            },            
            showInitialDialog(): boolean {
                return this.$store.state.ui.dialogVisible;
            },
            checkedIamHuman(): boolean {
                return this.$store.state.ui.checkedIamHuman;
            },
            textColourCss(): string {
                return this.$store.getters['textCssClass'];
            },
            humanDialogTitle(): string {
                return this.$vuetify.lang.t('webmap.humanDialog.title');
            },            
            humanCheckboxText(): string {
                return this.$vuetify.lang.t('webmap.humanDialog.text');
            },
            cookiePolicyText(): string {
                return this.$vuetify.lang.t('webmap.messages.cookiePolicy.text', this.$store.getters['getCookiePolicyUrl']);
            }
        },
        components: {
            'navigation-drawer': navigationDrawer,
            'application-side-panel': applicationPanel,
            'activity-snackbar': activitySnackBar,
            'cookie-snackbar': cookieSnackbar,
            'error-snackbar': errorSnackbar,
            'application-controls': contentControls,
            'speed-dial': speedDial,
            'culture-selector': cultureSelector,
            'notification-snackbar': notificationSnackbar,
            'toolstrip': toolstrip,
            'interactive-snackbar': interactiveSnackbar,
            'profile': profile,
            'home-button': homeButton
        },
        methods: {
            hideSearchResults(): void {
                this.$store.commit('setShowSearchResults', false);
            },
            showSearch(): void {
                this.$store.commit('setShowSearch', !this.$store.state.showSearch);
            },
            showMenu(): void {
                this.$store.commit('ui/setNavDrawerVisible', !this.$store.state.ui.navDrawerVisible);
            },
            transitionCompleteHandler(eventArgs): void {
                this.appPanelVisible = eventArgs.show;
            },
            resizeHandler(): void {
                if (this.$store.state.map.olMap) {
                    setTimeout(() => {
                        var el = document.getElementById(this.mapContainerId);
                        el.style.height = `${this.$vuetify.breakpoint.height - this.$vuetify.application.top}px`;

                        this.$store.state.map.olMap.updateSize();
                        this.$store.state.map.olMap.render();
                    }, 300);

                }
            },
            getLayerIndex(layer: any): string {
                const layerIndex = layer.get("layerIndex"); 
                return (layerIndex == null || layerIndex == undefined) ? "undefined" : layerIndex;
            },
            sortLayerByIndex(a: any, b: any): number {                 
                const layerIndexA = this.getLayerIndex(a); // this can be a string, e.g. '002' or '001_002', or even undefined
                const layerIndexB = this.getLayerIndex(b); // this can be a string, e.g. '002' or '001_002', or even undefined                                    
                if (layerIndexA === layerIndexB) return 0;
                return layerIndexB < layerIndexA ? 1 : -1;                
            },            
            onConfirmHuman(): void {
                if (!this.userIsHuman) return;
                this.humanDialogVisible = false;
                this.setCheckedIamHuman();
                this.continueLoadingMap();
            },
            startLoadingMap(): void {
                if (!this.$store.state.map.olMap) {
                    const centre: [number, number] = [this.$store.state.map.initialMapState.location[0], this.$store.state.map.initialMapState.location[1]];
                    const zoom: number = this.$store.state.map.initialMapState.zoom;
                    const extent: number[] = this.$store.state.map.initialMapState.viewExtent ? this.$store.state.map.initialMapState.viewExtent : null;
                    const resolutions: number[] = this.$store.getters['map/getResolutions'];
                    const viewOptions: { center: number[], projection: string, resolution: number, constrainResolution: boolean, extent?: number[], enableRotation: boolean, resolutions?: number[] } = { center: centre, projection: this.$store.state.map.initialMapState.projection, resolution: this.$store.state.map.initialMapState.zoom, constrainResolution: true, enableRotation: false  }

                    if (extent)
                        viewOptions.extent = extent;
                    if (resolutions)
                        viewOptions.resolutions = resolutions;
                    const theMap_view = new ol.View(viewOptions);
                    const calcScale = function (resolution: number): number {
                        const prj = theMap_view.getProjection();
                        const mPerUnit: number = prj.getMetersPerUnit();
                        const inchesPerM = 39.37;
                        const dpi = 90;
                        return Math.round(resolution * mPerUnit * inchesPerM * dpi);
                    };
                    theMap_view.on('change:resolution', () => {
                        const newRes: number = theMap_view.getResolution();
                        const scale = calcScale(newRes);
                        this.$store.commit('map/setScale', scale)
                    });

                    this.dataLayers = this.$store.state.map.dataLayers ? this.$store.state.map.dataLayers : []; 

                    var container = document.getElementById(this.mapContainerId);
                    container.style.height = `${this.$vuetify.breakpoint.height - this.$vuetify.application.top}px`;

                    this.baseLayers = this.$store.state.map.baseLayers ? this.$store.state.map.baseLayers : []; 

                    let map = new ol.Map({
                        view: theMap_view,
                        logo: '',
                        target: this.mapContainerId,
                        layers: this.baseLayers, // just put in base layers first, then add the rest in sorted order later.
                        controls: []
                    });

                    /* logic to get attributions resides here; Bing maps requires frameState (other types don't) but this odd requirement forces this logic here */
                    map.once('loadend', (e: any) => {  // event for panning and zooming map, hopefully not conflicting with rendercomplete                        
                        const attributions: string[] = this.getAttributions(e.frameState);
                        this.$store.commit('map/setAttributions', attributions);
                    });
                    

                    const initialRes: number = theMap_view.getResolution();
                    this.$store.commit('map/setScale', calcScale(initialRes))

                    if (this.mapControls && this.mapControls.length > 0) {
                        for (let contrlCount = 0; contrlCount < this.mapControls.length; contrlCount++) {
                            map.addControl(this.mapControls[contrlCount]);
                        }
                    }
                    this.$store.commit('map/setMap', map);

                    // Watermark layer setup
                    const watermark: IWatermark = this.$store.getters['map/getWatermark'];
                    if (watermark && Object.keys(watermark).length >= 4) {
                        const layerFactory = new LayerFactory();
                        const size: number[] = [watermark.width, watermark.height];

                        const watermarkLayer = new ol.layer.Tile({
                            map: map,
                            opacity: watermark.opacity,
                            visible: true,
                            source: new ol.source.TileImage({
                                crossOrigin: 'anonymous',
                                tileGrid: layerFactory.createTileGridFromProjection(theMap_view.getProjection(), size),
                                tileUrlFunction: function (tileCoord, pixelRatio, projection) { return watermark.url; }
                            })
                        });
                    }
                    this.handleInitialBaseLayer();
                } else {
                    var container = document.getElementById(this.mapContainerId);
                    container.style.height = `${this.$vuetify.breakpoint.height - this.$vuetify.application.top}px`;
                    this.$store.state.map.olMap.setTarget(document.getElementById(this.mapContainerId));

                    this.dataLayers = this.$store.state.map.dataLayers ? this.$store.state.map.dataLayers : [];
                    this.baseLayers = this.$store.state.map.baseLayers ? this.$store.state.map.baseLayers : []; 

                    this.$store.state.map.olMap.updateSize();
                    this.$store.state.map.olMap.render();                    
                }
            },
            continueLoadingMap(): void {
                this.$store.dispatch('extensions/activateDefault');
                const geognosisLayerId = this.$store.state.map.geognoSis.geognoSisLayerId;

                if (geognosisLayerId == null) {
                    this.finishLoadingMap([]); // no Geognosis overlay layers here
                    return;
                }                
                
                this.$store.commit('ui/setActivityMessage', this.$vuetify.lang.t('webmap.messages.geognosis.creatingSession'));
                let timeout = 1140000;//19 mins in milliseconds
                this.$store.dispatch('map/geognoSis/initialiseGeognoSIS')
                    .then(response => {
                        this.$store.commit('ui/setActivityMessage', this.$vuetify.lang.t('webmap.messages.geognosis.gettingOverlays'));
                        timeout = response.data.timeout;//in miliseconds.
                        //reduce by 30seconds
                        timeout -= 30000;
                        return this.$store.dispatch('map/geognoSis/getOverlaysFromServer');
                    })
                    .then(response => {                          

                        this.$store.commit('ui/setActivityMessage', this.$vuetify.lang.t('webmap.messages.geognosis.creatingLayers'));
                        const overlayLayers = [];
                        const ajax = new AjaxWrapper(this.$store.state.ajaxDefaults);                            
                        const layerFactory = new LayerFactory();

                        const singleTile: boolean = this.$store.getters['map/geognoSis/getSingleTile']; 
                        const extent: number[] | undefined = this.$store.getters['map/geognoSis/getExtent'];
                        const sessionId = this.$store.state.map.geognoSis.sessionId;

                        for (let overlayCount = 0; overlayCount < response.length; overlayCount++) {
                            const overlay = response[overlayCount];
                            if (!overlay.errorCondition) {
                                try {
                                    const layer = layerFactory.createLayer(overlay, this.$store.state.map.initialMapState.projection, sessionId, ajax, this.$store.state.map.geognoSis.tileSize, singleTile, extent);
                                    const opacity: number = this.$store.getters["map/geognoSis/getOpacity"];
                                    layer.setOpacity(opacity);
                                    // set a new property to help with sorting
                                    const paddedPrefix: string = this.$store.getters["map/geognoSis/layerIndexPrefix"]; // padded number e.g. '002'
                                    const paddedSuffix = overlay.m_overlayIndex.toString().padStart(3, '0'); // padded number e.g. '003'
                                    const combinedIndex = `${paddedPrefix}_${paddedSuffix}`; // sortable string e.g. '002_003' so that it ca be sorted by 2 variables
                                    layer.set("layerIndex", combinedIndex);

                                    // continue                                             
                                    overlayLayers.push(layer);
                                }
                                catch (err) {
                                    console.log(err);
                                }
                            }
                        }

                        this.initializeRefresher(timeout, geognosisLayerId, sessionId);                        

                        this.finishLoadingMap(overlayLayers);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$store.commit('ui/setActivityMessage', '');
                        this.$store.commit('ui/setErrorMessage', this.$vuetify.lang.t('webmap.messages.geognosis.error'));
                    });                                
            },
            initializeRefresher(timeout: number, geognosisLayerId: string, sessionId: string): void {
                let pinger: Worker = null;                
                try {
                    pinger = new Worker(`${this.$store.state.baseUrl}js/pinger.min.js`);
                    pinger.postMessage({ ajaxConfig: this.$store.state.ajaxDefaults, interval: timeout, cmd: 'start', actionUrl: `${this.$store.state.baseUrl}GeognoSis/${this.$store.state.mapName}/${geognosisLayerId}/${sessionId}/ping` });
                }
                catch (ex) {
                    console.log('pinger failed to initialise');
                    console.log(ex);
                }
                try {
                    const refresher = new Worker(`${this.$store.state.baseUrl}js/tokenRefresher.min.js`);
                    let token = this.$store.getters['getAuthorisation'];

                    refresher.onmessage = (eventArgs) => {
                        const data: { token: string, refreshToken: string, id: string } = eventArgs.data;
                        this.$store.commit('setRefreshToken', { token: data.refreshToken, id: data.id });
                        this.$store.commit('setAuthorisation', data.token);
                        if (pinger !== null) {
                            pinger.postMessage({ ajaxConfig: this.$store.state.ajaxDefaults, cmd: 'updateconfig' });
                        }
                    };
                    refresher.postMessage({ ajaxConfig: this.$store.state.ajaxDefaults, refreshInterval: this.$store.state.refreshInterval, cmd: 'start', actionUrl: `${this.$store.state.baseUrl}Account/refresh`, refreshToken: this.$store.state.token.token, id: this.$store.state.token.id, token: token });
                }
                catch (ex) {
                    console.log('refresher failed to initialise');
                    console.log(ex);
                }
            },            
            finishLoadingMap(overlayLayers): void {
                let combinedLayers = this.baseLayers.concat(this.dataLayers).concat(overlayLayers);
                combinedLayers.sort(this.sortLayerByIndex);
                const map = this.$store.state.map.olMap;
                map.setLayers(combinedLayers);   // added rest of layers and overlays in sorted order on top of base layers

                combinedLayers = this.dataLayers.concat(overlayLayers); // remove baselayers
                const visibleDataLayers: string[] = this.$store.getters['map/initialDataLayers']
                if (visibleDataLayers && visibleDataLayers.length > 0)
                    this.setDataLayerVisibility(visibleDataLayers, combinedLayers);

                combinedLayers.sort(this.sortLayerByIndex);  // sort this list of layers before committing to store to benefit other controls that list layers

                this.$store.commit('map/setDataLayers', combinedLayers);
                this.$store.commit('ui/setActivityMessage', '');

                // get and set attributions for toggling of layer visibility                
                const frameState = this.compileFrameState(map.getView());
                combinedLayers.forEach(x => {                    
                    x.on('change:visible', (e: any) => {
                        const attributions = this.getAttributions(frameState);
                        this.$store.commit('map/setAttributions', attributions);
                    });
                });

                // the baselayer(s) also need this extra logic
                this.baseLayers.forEach(x => {                    
                    x.on('change:visible', (e: any) => {
                        const attributions = this.getAttributions(frameState);
                        this.$store.commit('map/setAttributions', attributions);
                    });
                });                

                if (this.urlFullMapPromises && this.urlFullMapPromises.length > 0) {
                    Promise.all(this.urlFullMapPromises)
                        .then(() => {
                            this.setInitialLocation();
                            this.handleInitialRoute();
                        });
                }
                else {
                    this.handleInitialRoute();
                }
            },
            handleInitialBaseLayer(): void {
                if (this.$store.state.map.baseLayers && this.$store.state.map.baseLayers.length > 0) {
                    const baseLayer: string = this.$store.getters['map/initialBaseLayer'];
                    if (baseLayer) {
                        this.setBaseLayerVisible(baseLayer, this.$store.state.map.baseLayers);
                    }
                    else {
                        let foundVisible = false;
                        for (let c = 0; c < this.$store.state.map.baseLayers.length && !foundVisible; c++) {
                            if (this.$store.state.map.baseLayers[c].getVisible()) {
                                foundVisible = true;
                                this.$store.commit('map/setCurrentBaseLayer', this.$store.state.map.baseLayers[c]);
                            }
                        }
                    }
                }
            },
            setBaseLayerVisible(baseLayer: string, baseLayers: any[]): void {
                const found = baseLayers.find((layer) => {
                    return layer.get('name') === baseLayer;
                });
                const others = baseLayers.filter((layer) => {
                    return layer.get('name') !== baseLayer;
                });
                if (found !== null) {
                    found.setVisible(true);
                    this.$store.dispatch('map/setCurrentBaseLayer', found);
                }
                if (others && others.length > 0) {
                    for (let c = 0; c < others.length; c++) {
                        others[c].setVisible(false);
                    }
                }
            },
            setDataLayerVisibility(visibleDataLayers: string[], dataLayers: any[]) {
                const layers = [...dataLayers];
                for (let c = 0; c < visibleDataLayers.length; c++) {
                    const foundIndex = layers.findIndex((layer) => {
                        return layer.get('name') === visibleDataLayers[c] && !layer.get('isExtensionLayer') && !layer.get('userAdded');
                    });
                    if (foundIndex !== -1) {
                        const layer = layers[foundIndex];
                        layers.splice(foundIndex, 1);
                        layer.setVisible(true);
                        const source = layer.getSource()
                        if (source.overlay) {
                            const newStatus = source.overlay.maxStatus ? source.overlay.maxStatus : LayerStatus.Hittable;  // Cadcorp.Core.GeognoSIS.LayerStatusEnum: Invisible = 0, Visible = 1, Hittable = 2, Editable = 3       
                            layer.getSource().overlay.setStatus(newStatus);
                        }
                    }
                }
                if (layers.length > 0) {
                    for (let c = 0; c < layers.length; c++) {
                        const layer = layers[c];
                        if (!layer.get('isExtensionLayer') && !layer.get('userAdded')) {
                            layer.setVisible(false);
                            const source = layer.getSource();
                            if (source.overlay) {
                                source.overlay.setStatus(LayerStatus.Invisible);
                            }
                        }
                    }
                }
            },
            handleBookmarks(): Promise<boolean> {
                return new Promise( (resolve, reject) => {
                    const map = this.$store.state.map.olMap;
                    const view = map.getView();
                    const homeBookmark: IBookmark = this.$store.getters['bookmarks/homeBookmark'];
                    const loc = this.$store.getters['map/getInitialLocation'];
                    if (homeBookmark !== null) {
                        // initial location will be set if there are x and y parameters so don't override
                        if (loc === null) {
                            view.animate({ center: [homeBookmark.location.x, homeBookmark.location.y], resolution: homeBookmark.resolution, duration: 1500 });
                            //theMap_view.setCenter([homeBookmark.location.x, homeBookmark.location.y]);
                            //theMap_view.setResolution(homeBookmark.resolution);
                            const location: IInitialView = {
                                x: homeBookmark.location.x,
                                y: homeBookmark.location.y,
                                resolution: homeBookmark.resolution
                            }
                            this.$store.commit('map/setInitialLocation', location);
                        }
                    }
                    else {
                        // no home bookmark or initial location from url params (x and y)
                        // so set to current position
                        if (loc === null) {
                            this.setInitialLocation();
                        }
                    }
                    resolve(true);
                });
            },
            handleParameters(): Promise<boolean> {
                const params: IUrlParameters = this.$store.getters['getUrlParameters'];
                if(this.urlPromises.length > 0)
                    this.urlPromises = [];
                if (this.urlFullMapPromises.length > 0)
                    this.urlFullMapPromises = [];
                if (params !== null) { // we have a param object
                    const keys = Object.keys(params);
                    if (keys !== null && keys.length > 0) {//have params so handle them
                        for (let c = 0; c < keys.length; c++) { // the key is either an extension id or will resolve to a function
                            const id = keys[c];
                            const p = params[id];
                            const promises: Promise<boolean>[] = p.requiresFullMap ? this.urlFullMapPromises : this.urlPromises;
                            const ext: IUrlParamterHandler = this.$store.getters['extensions/getExtension'](id);// see if it's an extension 
                            if (ext) {// it is 
                                if (ext.handleUrlParameters) {// does it implement IUrlParamterHandler, if so use it
                                    promises.push(ext.handleUrlParameters.apply(ext, p.parameters));
                                }
                            }
                            else {
                                // something else possibly buried in a nest of namespaces
                                let f = null;
                                if (id.indexOf('.') === -1) {// no dots so a global function or object
                                    f = window[id];
                                }
                                else { // find our function or object
                                    const bits = id.split('.');
                                    let obj = window;
                                    for (let bit = 0; bit < bits.length; bit++) {
                                        obj = obj[bits[bit]];
                                    }
                                    f = obj;
                                }
                                if (typeof f === 'function') {
                                    promises.push(f.apply(window, p.parameters));
                                }
                                else if (typeof f === 'object') {
                                    //see if we have a handleUrlParameters function
                                    if (f.handleUrlParameters)
                                        promises.push(f.handleUrlParameters.apply(f, p.parameters))
                                }
                            }
                        }
                    }
                }
                let retVal: Promise<boolean> = null;
                if (this.urlPromises && this.urlPromises.length > 0)
                    retVal = Promise.all(this.urlPromises).then(() => {
                        this.setInitialLocation();
                        return true;
                    });
                else
                    retVal = this.handleBookmarks();
                return retVal;
            },
            handleInitialRoute(): void {
                let route = this.$store.getters['getInitialRoute'];
                if(route){
                    this.$router.replace({path:route });
                }
            },
            
            setCheckedIamHuman(): void {
                this.$store.commit('ui/setCheckedIamHuman', true);
            },
            /** Bing maps necessitates this function to be here and to be called from a map event such as moveend or loadend to get the frameState */
            getAttributions(frameState: any): string[] {
                const datalayers: any[] = this.$store.state.map.dataLayers.filter(x => x.getVisible && x.getVisible() && x.getSource && x.getSource()); 
                const baselayers = this.$store.state.map.baseLayers.filter(x => x.getVisible && x.getVisible() && x.getSource && x.getSource());
                const layers = datalayers.concat(baselayers);
                const yearRegEx = /%year%/gmi;
                let attributions: string[] = [];

                layers.forEach((layer, index) => {                    
                    const attr: Function = layer.getSource().getAttributions(); 
                    if (attr == undefined || attr == null) return;                    
                    let textOrArray: string | string[];
                    textOrArray = attr(frameState);  // Bing maps requires a 'frameState' argument; other layer types have no parameter
                    if (textOrArray instanceof Array) textOrArray = textOrArray.join('; ');                    
                    attributions.push(textOrArray);                
                });

                // replace %year% token with current year
                const date: Date = new Date(Date.now());
                const result = attributions.map(x => x.replace(yearRegEx, date.getFullYear().toString()));  

                // return result
                return result.length > 0 ? result : this.$store.state.copyright; 
            },
            compileFrameState(mapView) {
                return {
                    viewState: {
                        zoom: mapView.getZoom(),
                        center: mapView.getCenter(),
                        resolution: mapView.getResolution()
                    },
                    extent: mapView.calculateExtent()
                }
            },
            setInitialLocation() {
                const map = this.$store.state.map.olMap;
                const view = map.getView();
                const resolution = view.getResolution();
                const centre = view.getCenter();
                const location: IInitialView = {
                    x: centre[0],
                    y: centre[1],
                    resolution: resolution
                }
                this.$store.commit('map/setInitialLocation', location);
            }
        },
        beforeRouteLeave(to, from, next): void {
            this.$store.commit('ui/setNavDrawerVisible', false);
            next();
        },
        beforeMount(): void {            
            this.humanDialogVisible = this.showHumanDialogSetting && !this.checkedIamHuman;            
        },
        mounted(): void {

            this.$nextTick(function () { //all the dom elements will be available now so create the map
                let pageClose = false;
                window.addEventListener('pagehide', (event) => {
                    if (!event.persisted) {
                        // If the event's persisted property is not `true` the page is
                        // about to be unloaded.
                        pageClose = true;
                        console.log("page hide");
                        setTimeout(function () {
                            pageClose = false;
                        }, 1000);
                    }
                }, {capture: true});

                setTimeout(function () {
                    pageClose = false;
                }, 1000);

                document.addEventListener('visibilitychange', (event) => {
                    if (document.visibilityState === 'hidden') {
                        if (pageClose) {//we are being unloaded 
                            navigator.sendBeacon(`${this.$store.getters['baseUrl']}account/remove?id=${this.$store.getters['getTokenId']}`);
                            console.log("closing tab");
                        }
                    }
                }, { capture: true }); 
                if (!this.$store.state.map.olMap) { //no map yet, so lets set it up
                    this.startLoadingMap();
                    this.$store.dispatch('bookmarks/getLocalBookmarksForMap', this.$store.state.mapName)
                        .then(this.handleParameters)
                        .then(() => {
                            if (this.showHumanDialogSetting || this.humanDialogVisible) return;
                            this.continueLoadingMap();
                        });
                }
                else {// we have a map so we're probably coming back from a different app route
                    // so lets move it to our container and redraw
                    this.$store.state.map.olMap.setTarget(document.getElementById(this.mapContainerId));
                    this.$store.state.map.olMap.updateSize();
                    this.$store.state.map.olMap.render();
                }

            });
        }
    });
  